import XLSX from "xlsx-js-style"

const downloadWorkbook = (workbook, fileName) => {
  XLSX.writeFile(workbook, `${fileName}.xlsx`)
}

export const exportStyledXlsx = ({ rows = [], fileName = "export", cancelledRowPredicate = () => false }) => {
  const worksheet = XLSX.utils.json_to_sheet(rows)
  const workbook = XLSX.utils.book_new()

  const range = XLSX.utils.decode_range(worksheet["!ref"] || "A1:A1")
  const headerStyle = {
    font: { bold: true, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "4F63E6" } },
    alignment: { horizontal: "center" },
  }
  const cancelledStyle = {
    fill: { fgColor: { rgb: "F8D7DA" } },
    font: { color: { rgb: "842029" } },
  }

  for (let col = range.s.c; col <= range.e.c; col += 1) {
    const headerCell = XLSX.utils.encode_cell({ r: 0, c: col })
    if (worksheet[headerCell]) worksheet[headerCell].s = headerStyle
  }

  rows.forEach((row, rowIndex) => {
    if (!cancelledRowPredicate(row)) return
    for (let col = range.s.c; col <= range.e.c; col += 1) {
      const cellRef = XLSX.utils.encode_cell({ r: rowIndex + 1, c: col })
      if (worksheet[cellRef]) worksheet[cellRef].s = cancelledStyle
    }
  })

  worksheet["!cols"] = Object.keys(rows[0] || {}).map(key => ({
    wch: Math.max(14, String(key).length + 2),
  }))

  XLSX.utils.book_append_sheet(workbook, worksheet, "Report")
  downloadWorkbook(workbook, fileName)
}
